import { Level } from "../Level.js";
import { GRID_W, GRID_H } from "../../config/constants.js";
import { finalize } from "./helpers.js";

/**
 * Boss arena — a single big open square dungeon hall with pillars for cover.
 * Used on boss floors instead of the usual rooms-and-corridors layout. Renders
 * with the dungeon theme's walls/floor; the Game spawns the boss + adds into it.
 */
export function generateArena(floor, theme) {
  const level = new Level(GRID_W, GRID_H, theme);

  // one large centred square room (walls everywhere outside it)
  const W = Math.min(GRID_W - 4, 28), H = Math.min(GRID_H - 4, 28);
  const x0 = Math.floor((GRID_W - W) / 2), y0 = Math.floor((GRID_H - H) / 2);
  for (let y = y0; y < y0 + H; y++)
    for (let x = x0; x < x0 + W; x++) level.setFloor(x, y, (x + y) % 2);

  // enter from the south (well inside the room, not against the wall); the boss
  // waits to the north. Both are centred so the fight reads inside the arena.
  const midX = x0 + Math.floor(W / 2);
  level.playerStart = { gx: midX, gy: y0 + H - 5 };
  level.bossSpot = { gx: midX, gy: y0 + 4 };

  // pillars for cover — an even grid, inset from the walls, open lanes + centre
  const cxg = x0 + Math.floor(W / 2), cyg = y0 + Math.floor(H / 2);
  const pillar = (gx, gy) => level.addProp({
    gx: gx + 0.5, gy: gy + 0.5, shape: "pillar", color: 0x8a8275,
    blocking: true, scale: 1.35, rot: 0,
    key: theme.assets && theme.assets.pillar ? theme.assets.pillar : null,
  });
  const clearOf = (gx, gy, sx, sy, r) => Math.abs(gx - sx) <= r && Math.abs(gy - sy) <= r;
  for (let gy = y0 + 4; gy <= y0 + H - 5; gy += 5)
    for (let gx = x0 + 4; gx <= x0 + W - 5; gx += 5) {
      if (Math.abs(gx - cxg) <= 1 && Math.abs(gy - cyg) <= 1) continue;              // open middle
      if (clearOf(gx, gy, midX, y0 + 4, 1)) continue;                                // boss spot
      if (clearOf(gx, gy, midX, y0 + H - 5, 2)) continue;                            // player entrance
      pillar(gx, gy);
    }

  // spawn candidates across the northern two-thirds (boss + adds are placed by Game)
  for (let y = y0 + 1; y < y0 + H - 5; y++)
    for (let x = x0 + 2; x < x0 + W - 2; x++)
      if ((x + y) % 3 === 0) level.spawnPoints.push({ gx: x + 0.5, gy: y + 0.5 });

  finalize(level, 5);
  return level;
}
